import React, { useState } from 'react';
import {
  MagnifyingGlassIcon,
  BellIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';
import { cn } from '@/utils/cn';
import { PerformanceDashboard } from './PerformanceDashboard';

interface QuickActionsProps {
  userEmail?: string | null;
  onSignOut: () => void;
  className?: string;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  userEmail,
  onSignOut,
  className,
}) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [performanceDashboardOpen, setPerformanceDashboardOpen] =
    useState(false);

  const handleGlobalSearch = () => {
    setSearchOpen(!searchOpen);
    // TODO: Implement global search functionality
  };

  const handleNotifications = () => {
    // TODO: Implement notifications functionality
  };

  return (
    <>
      <div className={cn('flex items-center space-x-3', className)}>
        <button
          onClick={handleGlobalSearch}
          className="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
          title="Global Search"
        >
          <MagnifyingGlassIcon className="w-5 h-5" />
        </button>

        <button
          onClick={() => setPerformanceDashboardOpen(true)}
          className="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
          title="Performance Dashboard"
        >
          <ChartBarIcon className="w-5 h-5" />
        </button>

        <button
          onClick={handleNotifications}
          className="relative flex items-center justify-center w-8 h-8 text-gray-400 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
          title="Notifications"
        >
          <BellIcon className="w-5 h-5" />
          {/* Notification badge - TODO: Connect to real notification system */}
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-error-500 rounded-full"></span>
        </button>

        {/* User Menu */}
        <div className="relative group">
          <button className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
            <UserCircleIcon className="w-6 h-6" />
            <span className="hidden sm:block text-sm font-medium">
              {userEmail?.split('@')[0]}
            </span>
          </button>

          {/* Dropdown Menu */}
          <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
            <div className="py-1">
              <div className="px-4 py-2 border-b border-gray-700">
                <p className="text-sm font-medium text-white">{userEmail}</p>
                <p className="text-xs text-gray-400">Administrator</p>
              </div>
              <button
                onClick={onSignOut}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
              >
                <ArrowRightOnRectangleIcon className="w-4 h-4 mr-3" />
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Performance Dashboard Modal */}
      <PerformanceDashboard
        isOpen={performanceDashboardOpen}
        onClose={() => setPerformanceDashboardOpen(false)}
      />
    </>
  );
};
